import type { SectionAddendumAttachment } from 'pages/reporting/reports/rug/rugReportData'
import { PDFDocument } from 'pdf-lib'

import { inspectAttachmentPdf } from './attachmentPdf'

export function getAttachmentFileKind(file: {
  name: string
  size: number
}): 'image' | 'pdf' {
  const extension = file.name.split('.').at(-1)?.toLowerCase()
  if (!extension || !['png', 'jpg', 'jpeg', 'pdf'].includes(extension)) {
    throw new Error('Choose a PNG, JPEG, or PDF file')
  }
  if (file.size === 0) throw new Error('The selected file is empty')
  const limit = extension === 'pdf' ? 20 : 5
  if (file.size > limit * 1024 ** 2)
    throw new Error(`File must be no larger than ${limit} MB`)
  return extension === 'pdf' ? 'pdf' : 'image'
}

export async function inspectAttachmentFile(
  file: File
): Promise<SectionAddendumAttachment> {
  const kind = getAttachmentFileKind(file)
  const extension = file.name.split('.').at(-1)?.toLowerCase()
  const id = crypto.randomUUID()
  const common = {
    id,
    path: `sectionAddendums/${id}.${extension}`,
    fileName: file.name,
  }
  const bytes = await file.arrayBuffer()
  if (kind === 'pdf') {
    return { ...common, kind, pageCount: await inspectAttachmentPdf(bytes) }
  }
  try {
    const document = await PDFDocument.create()
    if (extension === 'png') await document.embedPng(bytes)
    else await document.embedJpg(bytes)
  } catch {
    throw new Error(
      'This image cannot be read. Choose a valid PNG or JPEG file.'
    )
  }
  return { ...common, kind }
}
